var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStempelToolAktiv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Stempel-Tool-Aktiv__Icn/40px/Stempel-Tool-Aktiv",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Stempel-Tool-Aktiv__Color/Transp_00",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0z",
    id: ".._.._src_svg_Icn_40px_Stempel-Tool-Aktiv__Rectangle"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M21.0002857,13 L20.998,19.999 L28,20 L28,26 L20.998,25.999 L21.0002857,33 L15.0002857,33 L14.999,25.999 L8,26 L8,20 L14.999,19.999 L15.0002857,13 L21.0002857,13 Z M19,15 L17,15 L16.999,22 L10,22 L10,24 L16.999,24 L17,31 L19,31 L18.999,24 L26,24 L26,22 L18.999,22 L19,15 Z M29,4 C32.8659932,4 36,7.13400675 36,11 C36,14.8659932 32.8659932,18 29,18 C25.1340068,18 22,14.8659932 22,11 C22,7.13400675 25.1340068,4 29,4 Z M29,6 C26.2385763,6 24,8.23857625 24,11 C24,13.7614237 26.2385763,16 29,16 C31.7614237,16 34,13.7614237 34,11 C34,8.23857625 31.7614237,6 29,6 Z M29,7 C31.209139,7 33,8.790861 33,11 C33,13.209139 31.209139,15 29,15 C26.790861,15 25,13.209139 25,11 C25,8.790861 26.790861,7 29,7 Z M29,9 C27.8954305,9 27,9.8954305 27,11 C27,12.1045695 27.8954305,13 29,13 C30.1045695,13 31,12.1045695 31,11 C31,9.8954305 30.1045695,9 29,9 Z",
    id: ".._.._src_svg_Icn_40px_Stempel-Tool-Aktiv__Combined-Shape"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStempelToolAktiv);
export default __webpack_public_path__ + "static/media/Stempel-Tool-Aktiv.8b2863f7cbcfd0ade76e2f9c526d06e4.svg";
export { ForwardRef as ReactComponent };